<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" content="查看商品"></el-page-header>
		<el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">
			<Tabs v-model="currentTab">
				<TabPane label="基础设置">
					<el-form-item label="商品名称" prop="name">
						<el-input v-model="item.name" placeholder="请输入商品名称"></el-input>
					</el-form-item>
					<el-form-item label="副标题">
						<el-input v-model="item.caption" placeholder="请输入副标题"></el-input>
					</el-form-item>
					<el-form-item label="所属品牌">
						<el-select v-model="item.brand_id" filterable placeholder="请选择">
							<el-option v-for="item in brandList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="平台分类" prop="product_category_id">
						<el-cascader v-model="item.product_category_id" placeholder="请选择" :options="adminCategoryList"
									 :props="filterProps" clearable></el-cascader>
					</el-form-item>
					<el-form-item label="商品分类" prop="store_category_id">
						<el-cascader v-model="item.store_category_id" placeholder="请选择" :options="storeCategoryList" :props="filterProps" clearable></el-cascader>
					</el-form-item>
					<el-form-item label="运费模板" prop="delivery_id">
						<el-select v-model="item.delivery_id" filterable placeholder="请选择">
							<el-option v-for="item in deliverys" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="list.itemKey" v-for="(list,index) in parameter">
						<el-input v-if="list.dataType == 1" v-model="list.itemValue" placeholder="请输入参数"></el-input>
						<el-date-picker v-else-if="list.dataType == 2" v-model="list.itemValue" type="date" placeholder="选择日期">
						</el-date-picker>
						<el-date-picker v-else-if="list.dataType == 3" v-model="list.itemValue" type="datetime"
										placeholder="选择日期时间">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="商品编码">
						<el-input v-model="item.sku_no" placeholder="请输入商品编码"></el-input>
					</el-form-item>
					<!-- <el-input v-model="item.caption" placeholder="请输入商品规格"></el-input> -->
					<div>
						<div class="goods-spec">
							<el-button type="primary" plain @click="addPrivateSpec">添加规格</el-button>
						</div>
						<div class="goods-container" v-for="(attr, index) in privateGoodsItem" :key="index">
							<div class="goods-content">
								<div class="goods-content-box">
									<div class="goods-content-left">
										<el-form-item label="规格名">
											<el-input v-model="attr.privateSpecName" placeholder="请输入规格名"></el-input>
										</el-form-item>
										<el-form-item label="规格值">
											<el-tag v-for="tag in attr.dynamicTags" :key="tag" closable
													:disable-transitions="false" @close="handleClose(tag, attr)">
												{{tag}}
											</el-tag>
											<!--  inputVisible控制是否显示  inputValue值 -->
											<!-- @keyup.enter.native点击回车的时候 判断是否有值决定是否隐藏 -->
											<!-- input失焦blur的时候 判断是否有值决定是否隐藏-->
											<el-input class="input-new-tag" v-show="attr.inputVisible" v-model="attr.inputValue"
													  :ref="`saveTagInput${index}`" size="small"
													  @keyup.enter.native="handleInputConfirm(attr.inputValue, attr)"
													  @blur="handleInputConfirm(attr.inputValue, attr)"></el-input>
											<el-button v-show="!attr.inputVisible" class="button-new-tag" size="small"
													   @click="showInput(attr, index)">+ 添加</el-button>
										</el-form-item>
									</div>
									<div class="goods-content-right">
										<el-link type="danger" @click="delPrivateSpec(index)">删除规格</el-link>
									</div>
								</div>
							</div>
						</div>
						<el-table style="margin-bottom: 22px; margin-top:0;" :data="oneFormBatch" border tooltip-effect="dark">
							<el-table-column label="规格">
								<template slot-scope="scope">
									批量设置
								</template>
							</el-table-column>
							<el-table-column label="图片">
								<template slot-scope="scope">
									<el-upload
											class="single-image single-image-small"
											list-type="single-image"
											:on-success="(value) => uploadSuccess1('oneFormBatch', 'single', value, scope.$index)"
											:show-file-list="false"
											:action="app_url + '/store/uploader/upload'">
										<i class="icon el-icon-plus" v-if="!oneFormBatch[scope.$index].product_image"></i>
										<img :src="oneFormBatch[scope.$index].product_image" v-else>
									</el-upload>
								</template>
							</el-table-column>
							<el-table-column label="销售价（元）">
								<template slot-scope="scope">
									<el-input v-model="scope.row.price"></el-input>
								</template>
							</el-table-column>
							<el-table-column label="成本价（元）">
								<template slot-scope="scope">
									<el-input v-model="scope.row.cost"></el-input>
								</template>
							</el-table-column>
							<el-table-column label="市场价（元）">
								<template slot-scope="scope">
									<el-input v-model="scope.row.market_price"></el-input>
								</template>
							</el-table-column>
							<el-table-column label="Sku编码">
								<template slot-scope="scope">
									<el-input v-model="scope.row.product_sku_no"></el-input>
								</template>
							</el-table-column>
							<el-table-column label="操作">
								<template slot-scope="scope">
									<el-button @click="batchAdd" type="success">批量添加</el-button>
									<el-button @click="batchDel" type="primary">清空</el-button>
								</template>
							</el-table-column>
						</el-table>
						<el-table style="margin-bottom: 22px; margin-top:0;" ref="multipleTable"
								  :data="tableColumnList.tableBodyList" border tooltip-effect="dark"
								  v-show="privateGoodsItem.length != 0">
							<el-table-column :label="item.propName" :property="item.prop"
											 v-for="item in tableColumnList.tableHeaderList" :key="item.prop" align="center">
								<template slot-scope="scope">
									<span>{{ scope.row[scope.column.property] }}</span>
								</template>
							</el-table-column>
							<el-table-column label="图片">
								<template slot-scope="scope">
									<el-upload
											class="single-image single-image-small"
											list-type="single-image"
											:on-success="(value) => uploadSuccess1('product_image', 'single', value, scope.$index)"
											:show-file-list="false"
											:action="app_url + '/store/uploader/upload'">
										<i class="icon el-icon-plus" v-if="!tableColumnList.tableBodyList[scope.$index].product_image"></i>
										<img :src="tableColumnList.tableBodyList[scope.$index].product_image" v-else>
									</el-upload>
								</template>
							</el-table-column>
							<el-table-column label="销售价（元）">
								<template slot-scope="scope">
									<el-input v-model="scope.row.price"></el-input>
								</template>
							</el-table-column>
							<el-table-column label="成本价（元）">
								<template slot-scope="scope">
									<el-input v-model="scope.row.cost"></el-input>
								</template>
							</el-table-column>
							<el-table-column label="市场价（元）">
								<template slot-scope="scope">
									<el-input v-model="scope.row.market_price"></el-input>
								</template>
							</el-table-column>
							<el-table-column label="Sku编码">
								<template slot-scope="scope">
									<el-input v-model="scope.row.product_sku_no"></el-input>
								</template>
							</el-table-column>
						</el-table>
					</div>

					<el-form-item label="商品主图" prop="product_pic_main">
						<el-upload
								class="single-image"
								list-type="single-image"
								:on-success="(value) => uploadSuccess('product_pic_main', 'single', value)"
								:show-file-list="false"
								:action="app_url + '/store/uploader/upload'">
							<div class="icon" v-if="!item.product_pic_main">
								<i class="el-icon-plus"></i>
								<span>图片规格：500px x 500px</span>
							</div>
							<img :src="item.product_pic_main" v-else>
						</el-upload>
					</el-form-item>
					<el-form-item label="细节图" prop="product_images">
						<div>
							<ul class="el-upload-list el-upload-list--picture-card">
								<li :tabindex="index" class="el-upload-list__item is-success" v-for="(src, index) in item.product_images" :key="index">
									<img :src="src" alt="" class="el-upload-list__item-thumbnail">
									<label class="el-upload-list__item-status-label">
										<i class="el-icon-upload-success el-icon-check"></i>
									</label>
									<i class="el-icon-close"></i><i class="el-icon-close-tip">按 delete 键可删除</i>
									<span class="el-upload-list__item-actions">
								<span class="el-upload-list__item-preview">
									<i class="el-icon-zoom-in"></i></span>
								<span class="el-upload-list__item-delete" @click="delectImage('product_images', index)">
									<i class="el-icon-delete"></i>
								</span>
							</span>
								</li>
							</ul>
							<el-upload
									class="single-image"
									style="display: inline"
									:multiple="true"
									:limit="10 - item.product_images.length"
									:action="app_url + '/store/uploader/upload'"
									list-type="picture-card"
									:show-file-list="false"
									:on-success="(value) => uploadSuccess('product_images', 'multi', value)">
								<div class="icon">
									<i class="el-icon-plus"></i>
									<span>图片规格：1125px x 817px</span>
								</div>
							</el-upload>
						</div>
					</el-form-item>
					<el-form-item label="商品详情" id="quill-upload">
						<el-upload :action="app_url + '/store/uploader/upload'"  multiple :show-file-list="false" :on-success="editorSuccess"
								   :on-error="uploadError" style="display: none;">
						</el-upload>
						<quill-editor ref="quill" v-model="item.introduction" :options="editorOption" />
					</el-form-item>
					<el-form-item label="驳回理由" v-if="this.authType == 2">
						<el-input v-model="item.memo" placeholder="" class="el-input-default-width-220"></el-input>
					</el-form-item>
				</TabPane>
				<TabPane label="营销设置">
					<el-form-item label="赠送积分" v-if="item.in_store">
						<el-input v-width="100" type="number" v-model="item.give_jifen"></el-input>
					</el-form-item>
					<el-form-item label="是否开启积分兑换">
						<el-switch v-model="item.is_points" active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#cccccc">
						</el-switch>
					</el-form-item>
				</TabPane>
			</Tabs>
			<el-form-item style="position: absolute;bottom: 10px;z-index: 1000">
				<el-button size="big" v-if="item.in_store" type="primary" @click="checkSubmit" v-auth="['store/product/update']">保存并提交审核</el-button>
			</el-form-item>
			<el-form-item>
				<el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
					<span>您确认保存嘛</span>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submit">确 定</el-button>
					</span>
				</el-dialog>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	import {
		quillEditor
	} from 'vue-quill-editor'
	export default {
		data() {
			return {
				currentTab: '',
				item: {
					product_pic_main: '',
					product_images: []
				},
				in_store: 0,
				filterProps: {
					value: 'id',
					label: 'name',
					emitPath: false,
					checkStrictly: true
				},
				isLoad: false,
				id: this.$route.query.id,
				dialogVisible: false,
				product_images: [],
				product_pic_main: [],
				canEdit: this.$route.query.op && this.$route.query.op == 1 ? true : false,
				op: 2, // 0-查看，1-新增，2-修改
				// 是否显示驳回理由
				authType: this.$route.query.authStatus ? this.$route.query.authStatus : -2,
				isView: false,
				supplierCategoryList: [], // 供应商商品分类列表
				brandList: [], // 品牌列表
				adminCategoryList: [], // 平台商品分类列表
				industryTemplateList: [], // 行业模板
				deliverys: [],
				parameter: [],

				tableColumnList: {
					tableHeaderList: [],
					tableBodyList: []
				},
				privateGoodsItem: [],
				// 方法的变量
				goods_option: [],
				storeCategoryList: [],

				editorOption: {
					modules: {
						toolbar: {
							container: [
								['bold', 'italic', 'underline', 'strike'],
								['blockquote', 'code-block'],
								[{
									'header': 1
								}, {
									'header': 2
								}],
								[{
									'list': 'ordered'
								}, {
									'list': 'bullet'
								}],
								[{
									'script': 'sub'
								}, {
									'script': 'super'
								}],
								[{
									'indent': '-1'
								}, {
									'indent': '+1'
								}],
								[{
									'direction': 'rtl'
								}],
								[{
									'size': ['small', false, 'large', 'huge']
								}],
								[{
									'header': [1, 2, 3, 4, 5, 6, false]
								}],
								[{
									'color': []
								}, {
									'background': []
								}],
								[{
									'font': []
								}],
								[{
									'align': []
								}],
								['clean'],
								['image', 'video']
							],
							handlers: {
								image: function(value) {
									if (value)
										document.querySelector('#quill-upload input').click()
									else
										this.quill.format('image', false);
								}
							}
						}
					},
				},
				rules: {
					name: [{
						required: true,
						message: '商品名称不存在',
						trigger: 'blur'
					}],
					brand_id: [{
						required: true,
						message: '请选择所属品牌'
					}],
					product_category_id: [{
						required: true,
						message: '请选择平台分类'
					}],
					store_category_id: [{
						required: true,
						message: '请选择商品分类'
					}],
					// industryTemplateId: [{
					// 	required: true,
					// 	message: '请选择模板'
					// }],
					delivery_id: [
						{
							required: true,
							message: '请选择运费模板'
						}
					],
					product_images: [{
						required: true,
						message: '细节图不存在'
					}],
					product_pic_main: [{
						required: true,
						message: '商品主图不存在'
					}],
				},
				// 批量设置表格data
				oneFormBatch: [
					{
						price: 0,
						market_price: 0,
						cost: 0,
						stock: 0,
						product_image: '',
						product_sku_no: ''
					},
				],
			}
		},
		created() {
			this.loadData()
		},
		computed: {
			// 规格名变化执行这个函数
			calculateAttribute() {
				let obj = {}
				// 规格数组，添加一个规格，里面就多一个
				this.privateGoodsItem.forEach((item) => {
					//privateSpecName 规格名
					if (item.privateSpecName) {
						// privateSpecName做键 item.dynamicTags做值
						//  规格名做键 规格值做值
						obj[item.privateSpecName] = item.dynamicTags
					}
				})
				return obj
			}
		},
		watch: {
			// 规格名的子元素规格值变化执行这个函数
			calculateAttribute(newVal) {
				// JSON.stringify() 方法用于将 JavaScript 值转换为 JSON 字符串。
				// JSON.parse() 方法将数据转换为 JavaScript 对象。
				let cloneNewVal = JSON.parse(JSON.stringify(newVal))
				let attrName = []
				let attrValue = []
				// cloneNewVal 里面 privateSpecName做键 item.dynamicTags做值
				for (let key in cloneNewVal) {
					// attrName 存储规格名
					attrName.push(key)
					// attrValue 存规格值
					attrValue.push(cloneNewVal[key])
				}
				// 将一维数组中的字符串拆为多维数组且交叉交叉交叉交叉交叉交叉
				console.log(attrValue,111);
				let finalArr = this.cartesianProductOf(...attrValue)
				let tableObj = {
					tableBodyList: [],
					tableHeaderList: []
				}
				// map转格式且拼接
				tableObj.tableBodyList = finalArr.map((item) => {
					// 获取规格所对应的值 由大|红|1 这样子的拆分，主要看的是this.goods_option的值
					let obj = {
						// this.goods_option[item.join('|')]是否存在 存在的话this.goods_option[item.join('|')]
						id: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].id : '',
						price: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].price :
							'',
						market_price: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')]
							.market_price : '',
						cost: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].cost : '',
						product_image: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].product_image : '',
						product_sku_no: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].product_sku_no : ''
					}

					// 因为已经交叉起来了,所以length有几个规格项就有几个
					for (let i = 0; i < item.length; i++) {
						// // attrName 存储规格名作为obj的键
						obj[attrName[i]] = item[i]
					}
					return obj
				})
				this.tableColumnList.tableBodyList = tableObj.tableBodyList
				// 获取规格项
				let skuTableArr = Object.keys(newVal)
				tableObj.tableHeaderList = skuTableArr.map((item) => {
					return {
						prop: item,
						propName: item
					}
				})
				this.tableColumnList.tableHeaderList = tableObj.tableHeaderList
			}
		},
		methods: {
			// 批量添加
			batchAdd() {
				for (let val of this.tableColumnList.tableBodyList) {
					if (this.oneFormBatch[0].price > 0) {
						this.$set(val, "price", this.oneFormBatch[0].price);
					}
					if (this.oneFormBatch[0].market_price > 0) {
						this.$set(val, "market_price", this.oneFormBatch[0].market_price);
					}
					if (this.oneFormBatch[0].cost > 0) {
						this.$set(val, "cost", this.oneFormBatch[0].cost);
					}
					if (this.oneFormBatch[0].product_image != '') {
						this.$set(val, "product_image", this.oneFormBatch[0].product_image);
					}
					if (this.oneFormBatch[0].product_sku_no != '') {
						this.$set(val, "product_sku_no", this.oneFormBatch[0].product_sku_no);
					}
				}
			},
			batchDel() {
				this.oneFormBatch = [
					{
						price: 0,
						market_price: 0,
						cost: 0,
						product_image: '',
						product_sku_no: ''
					},
				];
			},
			changeCategory(data) {

			},
			loadData: async function() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad

				// 供应商：商品分类树
				await this.axios.get('/store/data/getCategoryTreeStore', {}).then(res => {
					this.storeCategoryList = res.data.list
					this.isLoad = !this.isLoad
				}).catch(() => {
					this.isLoad = !this.isLoad
				})

				// 中控：商品分类树
				await this.axios.get('/store/data/getCategoryTreeAdmin', {}).then(res => {
					this.adminCategoryList = res.data.list
				})

				// 品牌列表
				await this.axios.get('/store/data/listBrandForSelect', {}).then(res => {
					this.brandList = res.data.list
				})

				await this.axios.get('/store/delivery/list', {}).then(res => {
					this.deliverys = res.data.list
				}).catch(() => {
				})

				// 获取商品信息
				if (this.id) {
					await this.axios.post('/store/product/detail', {
						id: this.id
					}).then(res => {
						if(res.data.detail.specifications){
							res.data.detail.specifications.forEach(key => {
								key.specValue = key.specValue.split(',')
								key.inputVisible = false
								key.inputValue = ''
							})

							res.data.detail.specifications.forEach((key, index) => {
								this.$set(key, 'dynamicTags', key.specValue)
								this.$set(key, 'privateSpecName', key.specName)
								this.tableColumnList.tableHeaderList[index] = {}
								this.$set(this.tableColumnList.tableHeaderList[index], 'propName', key.specName)
								this.$set(this.tableColumnList.tableHeaderList[index], 'prop', key.specName)
							})
							this.privateGoodsItem = res.data.detail.specifications
						}

						res.data.detail.sku.forEach((key, index) => {
							let skuName1 = key.sku_name.split(',')
							let skuNameArr = ''
							for (let i = 0; i < skuName1.length; i++) {
								skuNameArr += skuName1[i] + '|'
							}
							skuNameArr = skuNameArr.substr(0, skuNameArr.length - 1)
							let obj = {
								id: key.id,
								price: key.price,
								market_price: key.market_price,
								cost: key.cost,
								product_image: key.product_image,
								product_sku_no: key.product_sku_no
							}
							this.goods_option[skuNameArr] = obj
						})

						this.item = res.data.detail

						this.item.is_marketable = this.item.is_marketable.toString()
						this.item.is_points = this.item.is_points.toString()
						// this.item.store_category_id = this.item.store_category_id.toString()
						this.$forceUpdate()
					})
				}
			},
			// 后退一步
			goBack() {
				this.$router.back(-1)
			},
			checkSubmit() {
				// 存储图片且刷新 因为上传的和存储的图片不是同一个
				this.$refs["ruleForm"].validate((valid) => {
					if (valid) {
						this.dialogVisible = true
					} else {
						this.$message.warning("请检查表单信息是否正确");
						return false;
					}
				});
			},
			// 提交
			submit() {
				this.item.attr = this.parameter
				// 如果存在多规格的话 就将值传上去
				// 解析多规格
				let specifications = [];
				this.privateGoodsItem.forEach((item) => {
					//privateSpecName 规格名
					//dynamicTags 规格值
					if (item.privateSpecName) {
						let obj = {}
						obj.specName = item.privateSpecName;
						obj.specValue = item.dynamicTags.join(",");
						specifications.push(obj);
					}
				})
				this.item.specification = specifications;

				if (this.item.specification.length == 0) {
					this.$message.error({
						message: '规格不能为空'
					});
					this.dialogVisible = false
					return true;
				}

				if (this.isLoad) {
					return false
				}
				this.isLoad = !this.isLoad

				// 解析SKU
				let sku = [];
				this.tableColumnList.tableBodyList.forEach((item) => {
					let obj = {}
					obj.cost = item.cost;
					obj.market_price = item.market_price;
					obj.price = item.price;
					obj.product_image = item.product_image;
					obj.product_sku_no = item.product_sku_no;
					let skuName = '';
					this.tableColumnList.tableHeaderList.forEach((i) => {
						if (skuName != '') {
							skuName += ',';
						}
						skuName += item[i.propName];
					})
					obj.skuName = skuName;

					sku.push(obj);
				})
				this.item.sku = sku;

				let url
				url = '/store/product/update'

				this.axios.put(url, this.item)
				.then(() => {
					this.isLoad = !this.isLoad
					this.$message.success({
						message: '保存成功'
					});
					this.goBack()
				})
				.catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			// 添加规格项
			addPrivateSpec() {
				this.privateGoodsItem.push({
					privateSpecName: '',
					dynamicTags: [],
					inputVisible: false,
					inputValue: ''
				})
			},
			// 删除规格项
			delPrivateSpec(index) {
				this.privateGoodsItem.splice(index, 1)
			},
			// 添加input
			handleInputConfirm(val, attr) {
				if (val)
					attr.dynamicTags.push(val)
				attr.inputVisible = false
				attr.inputValue = ''
			},
			// 关闭且删除input
			handleClose(tag, item) {
				item.dynamicTags.splice(item.dynamicTags.indexOf(tag), 1)
			},
			// 失去焦点或者点击回车生成input
			showInput(attr, index) {
				attr.inputVisible = true
				this.$nextTick(() => {
					this.$refs[`saveTagInput${index}`][0].$refs.input.focus()
				})
			},
			// 让数据交叉交叉交叉交叉交叉交叉交叉交叉交叉交叉交叉
			cartesianProductOf(...args) {
				return args.reduce((total, current) => {
					let ret = []
					total.forEach((a) => {
						current.forEach((b) => {
							ret.push(a.concat([b]))
						})
					})
					return ret
				}, [
					[]
				])
			},

			uploadError() {
				this.$message.error({
					message: '上传失败'
				});
			},
			beforeUpload(file) {
				var testmsg = file.type;
				const extension = (testmsg === "image/jpeg" || testmsg === "image/png");
				if (!extension) {
					this.$message({
						message: "上传文件只能是jpg或png格式!",
						type: "warning",
					});
				}
				return extension;
			},
			uploadSuccess(key, model, res, file) {
				if (model == 'single') {
					this.item[key] = res.data.fileInfo.external_url
				} else {
					if (this.item[key] == '') {
						this.item[key] = []
					}
					this.item[key].push(res.data.fileInfo.external_url)
				}
				this.$forceUpdate()

			},
			uploadSuccess1(key, model, res, index) {
				if (key == 'oneFormBatch') {
					this.oneFormBatch[index].product_image = res.data.fileInfo.external_url
				} else {
					this.tableColumnList.tableBodyList[index].product_image = res.data.fileInfo.external_url
				}

				this.$forceUpdate()
			},
			delectImage: function (key, index) {
				this.item[key].splice(index, 1)
			},
			// 富文本图片上传
			editorSuccess(res) {
				let quill = this.$refs.quill.quill
				let length = quill.getSelection().index
				// 上传图片的路径
				quill.insertEmbed(length, 'image', res.data.fileInfo.external_url)
				quill.setSelection(length + 1)
				this.$message.success({
					message: '上传成功'
				});
			}
		},
		components: {
			quillEditor
		}
	}
</script>
<style scoped>
	.goods-spec {
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.goods-spec .goods-spec-add {
		margin-left: 30px;
		margin-bottom: 14px;
	}

	.goods-container .button-new-tag {
		height: 32px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;
	}

	.goods-container .input-new-tag {
		width: 90px;
		margin-right: 10px;
		vertical-align: bottom;
	}

	.goods-container .el-tag {
		margin-right: 10px;
	}

	.goods-container .goods-content {
		margin-bottom: 10px;
		padding: 14px;
		border: 1px solid #ebeef5;
		border-radius: 4px;
		background-color: #fcfcfc;
	}

	.goods-content .goods-content-box {
		display: flex;
		align-items: center;
	}

	.goods-content-box .goods-content-left {
		flex: 1;
	}
</style>
